
import Page from '@root/common/base/Page';
import PodcastSkeletonLoader from '@root/common/components/base/loader/PodcastSkeletonLoader.vue';
import { podcastFeedService } from '@root/modules/podcast/services/podcastFrontpage.service';
import Popular from '@root/modules/podcast/components/blocks/Popular.vue';
import ResumeListening from '@root/modules/podcast/components/blocks/ResumeListening.vue';
import CustomerPlaylist from '@root/modules/podcast/components/blocks/CustomerPlaylist.vue';
import Latest from '@root/modules/podcast/components/blocks/Latest.vue';
import TextToSpeech from '@root/modules/podcast/components/blocks/TextToSpeech.vue';
import Books from '@root/modules/podcast/components/blocks/Books.vue';
import Radios from '@root/modules/podcast/components/blocks/Radios.vue';
import Archive from '@root/modules/podcast/components/blocks/Archive.vue';
import { Feed } from '@root/modules/podcast/types/podcast';
import getFrontPageAdsSettings from '@root/modules/frontpage/utils/getFrontPageAdsSettings';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';

interface Data {
  feed: Feed;
  loaded: boolean;
}

interface Computed {
  mobileAds: string[] | null;
}

export default Page.extend<Data, unknown, Computed, unknown>({
  components: {
    PodcastSkeletonLoader,
    Popular,
    ResumeListening,
    CustomerPlaylist,
    Latest,
    TextToSpeech,
    Books,
    Radios,
    Archive,
    AdFormBanner,
  },
  data() {
    return {
      feed: {
        popular: [],
        latest: [],
        tts: [],
        books: [],
        radios: [],
        archive: [],
      },
      loaded: false,
    };
  },
  computed: {
    mobileAds() {
      const ads = this.$store.getters['adForm/getAdsPlacements'];

      return ads?.mobile?.mid || null;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.resetPageAdsSettings();
    next();
  },
  async fetch() {
    try {
      const feed = await podcastFeedService.fetch();
      this.feed = feed || this.$store.getters['frontpage/getFeedData'];
      this.$store.commit('frontpage/setFeedData', this.feed);

      this.setPageAdsSettings(getFrontPageAdsSettings({ $channelConfig: this.$channelConfig }));

      this.loaded = true;
    } catch (e) {
      this.handlePageError(e);
    }
  },
  mounted() {
    this.restoreScroll();
  },
  head() {
    const settings = this.$channelConfig('meta').base;
    const meta = this.getPageMeta();
    meta.setTitle({ title: settings.title });

    return {
      title: meta.title,
      link: meta.link,
    };
  },
});
